import { TeamMembersFormat as TeamMembersFormatI } from '../../models/common';

import TeamInitialAnimation from './TeamInitialAnimation';
import TeamList from './TeamList';

export type Props = {
  data: TeamMembersFormatI[];
};

const Team = (props: Props): JSX.Element => {
  const { data } = props;

  return (
    <>
      <TeamInitialAnimation data={data} />
      <TeamList data={data} />
    </>
  );
};

export default Team;
